import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { founding } from "@/content/copy";
import { Eyebrow, Reveal } from "./primitives";
import { Sapling } from "./Sapling";

const ease = [0.22, 1, 0.36, 1];

const Reflection = () => (
  <motion.div key="reflection" data-testid="founder-reflection" initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.6, ease }} className="overflow-hidden">
    <div className="ph-angle mt-10">
      <p className="ph-angle-label">{founding.reflectionLabel}</p>
      {founding.reflection.map((p, i) => (
        <p key={i} className="ph-reflection mt-5">{p}</p>
      ))}
    </div>
  </motion.div>
);

export const FoundingQuestion = () => {
  const [open, setOpen] = useState(false);
  return (
    <section id="founding-question" data-testid="founding-question-section" className="ph-section ph-cream-section scroll-mt-20">
      <div className="ph-container relative">
        <Reveal className="flex items-start justify-between gap-6">
          <Eyebrow className="ph-eyebrow-dark mt-2">{founding.eyebrow}</Eyebrow>
          <Sapling />
        </Reveal>
        <Reveal className="mt-8 sm:mt-10 lg:max-w-[75%]">
          <h2 data-testid="founding-question-heading" className="ph-question">{founding.heading}</h2>
        </Reveal>
        <div className="mt-10 sm:mt-14 lg:ml-[16.66%] lg:max-w-[58%]">
          <Reveal><p data-testid="founding-question-opening" className="ph-lead ph-ink-soft">{founding.opening}</p></Reveal>
          <Reveal delay={0.1}>
            <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open} aria-controls="founder-reflection-panel" data-testid="btn-founder-reflection" className="ph-btn ph-btn-ink mt-10">
              <span>{founding.button}</span>
              <motion.span className="ph-btn-icon" animate={{ rotate: open ? 180 : 0 }} transition={{ duration: 0.5, ease }} aria-hidden="true"><ChevronDown size={18} /></motion.span>
            </button>
          </Reveal>
          <div id="founder-reflection-panel">
            <AnimatePresence initial={false}>{open && <Reflection />}</AnimatePresence>
          </div>
          <Reveal className="mt-14 sm:mt-16 pt-10 border-t border-[var(--blue)]/25">
            <p data-testid="founding-closing-question" className="ph-closing">{founding.closing}</p>
          </Reveal>
          <Reveal delay={0.1} className="mt-8">
            <p data-testid="founding-development-note" className="ph-note ph-note-ink">
              <span className="ph-note-mark" aria-hidden="true">*</span>{founding.note}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
